module.exports = __webpack_public_path__ + "static/img/in.e4ab7bd0.svg";